import { useTheme } from '@mui/material';
import { useMemo } from 'react';
import { Coords } from './map/coords';
import { MapMarkerWrapper } from './map/MapMarkerWrapper';

export type BusinessAccountLocationType = 'degassed' | 'raw';

interface TankMarkerProps extends Coords {
  tankType: BusinessAccountLocationType;
  onClick: () => void;
  style?: React.CSSProperties;
}

export const TankMarker: React.FC<TankMarkerProps> = ({
  tankType,
  onClick,
  style,
}) => {
  const { palette } = useTheme();

  const colors = useMemo(
    () => ({
      raw: palette.cyan[600],
      degassed: palette.warning[800],
    }),
    [palette]
  );

  return (
    <MapMarkerWrapper onClick={onClick} style={style}>
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill={colors[tankType]}
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="5.17627"
          cy="5"
          r="3.75"
          fill="#00ADC7"
          stroke="white"
          stroke-width="1.5"
        />
      </svg>
    </MapMarkerWrapper>
  );
};
